import React from 'react';
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import ProspectHeadingTabPartial
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/ProspectHeadingTabPartial/ProspectHeadingTabPartial";
import {Link} from "react-router-dom";
import {PolIcon} from "components/PolIcon/policon";
import ProspectStats360Modules
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectStats360Tab/components/ProspectStats360Modules/ProspectStats360Modules";
import {useProspectPageContext} from "v4/contexts/ProspectPageContext";
import useGetProspectStats360Modules
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectStats360Tab/hooks/useGetProspectStats360Modules";
import ProspectStats360TabProductViewActions
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectStats360Tab/components/ProspectStats360TabProductViewActions/ProspectStats360TabProductViewActions";
import i18n from "i18next";

export default function ProspectStats360TabGeneralView({isProductView}) {
    const {prospectId} = useProspectPageContext();
    const { getRouteByNativeIdentifier } = useNavigation();
    const {
        modules,
        hasProducts,
        isLoading,
        gridRef,
        methods,
        filters,
    } = useGetProspectStats360Modules(isProductView);

    return (
        <>
            <ProspectHeadingTabPartial titleSuffix={isProductView ? "products_view" : "general_view"}
                                       actions={getProspectStats360TabGeneralViewActions({
                                           hasProducts,
                                           isProductView,
                                           prospectId,
                                           getRouteByNativeIdentifier,
                                           modules,
                                           methods,
                                       })}/>
            <ProspectStats360Modules modules={modules} filters={filters} isLoading={isLoading} ref={gridRef}/>
        </>
    )
}

function getProspectStats360TabGeneralViewActions({hasProducts, isProductView, prospectId, methods, modules, getRouteByNativeIdentifier}) {
    if (isProductView) return () => (
        <ProspectStats360TabProductViewActions methods={methods} productsModules={modules?.products}/>
    )

    if (hasProducts) return () => (
        <Link
            to={`/${resolveUrl(getRouteByNativeIdentifier('detail_stats_360')?.url, {prospect: prospectId})}/product-view`}
            className="prospect-tab__action stats">
            {i18n.t('products_view')}
            <PolIcon icon="return" size={14} className="reverse-h"/>
        </Link>
    )

    return undefined;
}
